import React, { useRef, useState, useEffect } from 'react'
import './ScreenPatrocina.css'

const sponsors = [
  {
    image: 'images/patrocina/biovetix_logo.png',
    link: 'https://www.biovetix.com/'
  },
  {
    image: 'images/patrocina/fallabrino_logo.png',
    link: 'http://www.bodegapablofallabrino.uy/',
    className: 'pa-img-fallabrino'
  },
  {
    image: 'images/patrocina/meraki_brown_logo.png',
    link: 'https://merakisustentable.com/uy/'
  },
  {
    image: 'images/patrocina/ursal_logo.png',
    link: 'http://www.urusal.com/',
    className: 'pa-img-urusal'
  },
  {
    image: 'images/patrocina/revaso.png',
    link: 'https://www.revaso.uy/'
  },
  {
    image: 'images/patrocina/malafama.png',
    link: 'https://cervezamalafama.com/'
  },
  {
    image: 'images/patrocina/indie.png',
    link: 'https://indie.uy/',
    className: 'pa-img-indie'
  },
  {
    image: 'images/patrocina/epbelec.png',
    link: 'https://www.epbelec.fr/'
  }
]

const desplazamientos = [0, 2, 3, 4]

const ScreenPatrocina = () => {
  const patrocinarBtnRef = useRef(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex =>
        prevIndex === sponsors.length - 1 ? 0 : prevIndex + 1
      )

      if (patrocinarBtnRef.current) {
        patrocinarBtnRef.current.classList.toggle('scaling-animation')
      }
    }, 3000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const handleClick = link => {
    window.location.href = link
  }

  const obtenerSponsor = (index, desplazamiento) => {
    const sponsorIndex = (index + desplazamiento) % sponsors.length
    return sponsors[sponsorIndex]
  }

  return (
    <div className='screen-patrocina-container'>
      <div className='image-links-container'>
        {desplazamientos.map((desplazamiento, filaIndex) =>
          sponsors.map((_, index) => {
            const sponsor = obtenerSponsor(index, desplazamiento)

            return (
              <img
                key={`${filaIndex}-${index}-${sponsor.image}`}
                src={sponsor.image}
                alt={`Sponsor ${index + 1}`}
                className={
                  `${currentImageIndex === index ? 'active' : ''} ${sponsor.className || ''}`
                }
                onClick={() => handleClick(sponsor.link)}
              />
            )
          })
        )}

        <img
          ref={patrocinarBtnRef}
          src='images/patrocina/PATROCINAR_B.png'
          alt='Patrocinar'
          onClick={() => handleClick('link4')}
          className='active'
        />
      </div>
    </div>
  )
}

export default ScreenPatrocina